import React from 'react'
import { Box, Flex, Text, useColorModeValue } from '@chakra-ui/react'
import CardHeader from 'components/Card/CardHeader'
import CardBody from 'components/Card/CardBody'
import Card from 'components/Card/Card'

export function VideoPreview({ url }) {
  const textColor = useColorModeValue('gray.700', 'white')
  return (
    <Card my={{ lg: '24px' }} me={{ lg: '24px' }}>
      <Flex direction="column">
        <CardHeader py="12px">
          <Flex direction="column">
            <Text color={textColor} fontSize="lg" fontWeight="bold">
              Generated Video
            </Text>
          </Flex>
        </CardHeader>
        <CardBody>
          <Flex direction="column" w="100%">
            <Box mb="20px" position="relative" borderRadius="15px">
              <video
                controls
                style={{
                  width: '100%',
                  maxWidth: '100%',
                  height: 'auto',
                }}
              >
                <track kind="captions" />
                <source src={url} />
              </video>
            </Box>
          </Flex>
        </CardBody>
      </Flex>
    </Card>
  )
}
